export default __webpack_public_path__ + "static/media/img10.b3f73fe7.jpg";